import { HoopsApi, useAPIAction } from "melco-shared-logic";

export const useUploadHoopAsset = (hoopCloudId: string) => {
  const [uploadHoopAsset] = useAPIAction(
    HoopsApi,
    async (api, file: Blob) => {
      let response = await api.hoopsUpload({
        id: hoopCloudId,
        file: file,
      });

      return {
        successMessages: [{ message: "default" }],
        data: response,
      };
    },
    {
      translationPrefix: "managehoops.actions.assetupload",
    }
  );
  return {
    uploadHoopAsset,
  } as const;
};
